import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLoginModal } from '../../login/useLoginModal';
import { NavItemButton } from '../components/item/NavItem';

export const NavLoginButton: React.FC = () => {
  const { openLoginModal } = useLoginModal();

  return (
    <NavItemButton
      dataTestId="login-button"
      id="nav_connection_button"
      dataSource="header"
      onClick={() => openLoginModal({ source: 'nav-login' })}
    >
      <FormattedMessage id="navigation/login/NavLoginButton.tsx/1" />
    </NavItemButton>
  );
};
